module.exports = __webpack_public_path__ + "img/marine_app_9.54a84bdb.jpg";